<header class="section-header">
  <h2>هویت الکتریکی پیشرفته · نسخه 2</h2>
  <span>8 شاخص مرجع</span>
</header>
<dl class="electrical-overview">
  <div class="electrical-tile" *ngFor="let metric of metrics">
    <dt>{{ metric.label }}</dt>
    <dd dir="ltr">{{ formatValue(context.summary, metric.field, 4, metric.unit) }}</dd>
  </div>
</dl>
<p class="chart-note">مقادیر مستقیماً از مرجع فعال دریافت می‌شوند.</p>
